import Title from './title'

export default function ApplyForms({ applyForms, studioName }) {
  const t = useI18n()
  if (!applyForms.length) return ''

  return (
    <div>
      <div className='py-5'>
        <div className=''/>
      </div>
      <Title>{ t('page:studioId.events') }</Title>
      <div className='mt-2 grid grid-cols-1 sm:gap-4 sm:grid-cols-2'>
        { applyForms.map(applyForm => (
          <Row
            key={ applyForm.slug }
            applyForm={ applyForm }
            studioName={ studioName }
            t={ t }
          />
        )) }
      </div>
    </div>
  )
}

const Row = ({ applyForm, studioName, t }) => {

  const renderImage = ({ src, className }) => {
    if (!src) return <div className={ cn('bg-gray-100', className) }></div>
    return <C.Image
      src={ src }
      className={ className }
    />
  }

  return (
    <C.Link href={ h.path.apply({ slug: applyForm.slug }) } noUnderline>
      <div className='mb-6'>

        <div className='flex rounded-[10px] overflow-hidden relative'>
          <div className='flex-[2_0_0%] m-0'>
            { renderImage({
              src: applyForm.coverUrls[0]?.large.url,
              className: 'pt-[100%]'
            }) }
          </div>
          <div className='flex-1 flex flex-col'>
            { renderImage({
              src: applyForm.coverUrls[1]?.small.url,
              className: 'pt-[100%]'
            }) }
            { renderImage({
              src: applyForm.coverUrls[2]?.small.url,
              className: 'pt-[100%]'
            }) }
            <div className='absolute inset-0 bg-black/50 text-white flex flex-col items-center justify-center opacity-100 hover:backdrop-blur-sm hover:bg-black/70 transition-all'>
              <div className='line-clamp-1 text-[1.3rem] px-3'>{ studioName }</div>
              <div className='line-clamp-1 text-[1.2rem] px-3'>{ t('page:studioId.price', { tag: applyForm.tags[0] }) }</div>
            </div>
          </div>
        </div>

        <div className='pt-[0.15rem] font-medium line-clamp-1'>{ applyForm.title }</div>

      </div>
    </C.Link>
  )
}